import PropTypes from 'prop-types';
import { IconButton, Icon } from '@openedx/paragon';
import { RiEyeLine, RiDownloadLine } from '@remixicon/react';
import { FormattedMessage, useIntl } from '@edx/frontend-platform/i18n';

import FileTypeBadge from './FileTypeBadge';
import messages from '../messages';
import pdfIcon from '../../../assets/svg/pdf.svg';
import docxIcon from '../../../assets/svg/docx.svg';
import pptxIcon from '../../../assets/svg/pptx.svg';
import xlsxIcon from '../../../assets/svg/xlsx.svg';

const TYPE_TO_ICON = {
  pdf: pdfIcon,
  pptx: pptxIcon,
  docx: docxIcon,
  xlsx: xlsxIcon,
};

const FileCard = ({ file, onPreview, onDownload }) => {
  const { formatMessage } = useIntl();
  const thumbSrc = TYPE_TO_ICON[file.type];
  return (
    <article className={`file-card file-card--${file.type}`}>
      <div className="file-card__top">
        <div className="file-card__thumb">
          {thumbSrc && <img src={thumbSrc} alt="" className="file-card__thumb-img" />}
        </div>
        <div className="file-card__meta">
          <h3 className="file-card__name" title={file.name}>{file.name}</h3>
          <p className="file-card__updated">
            <FormattedMessage
              {...messages.lastUpdatedLabel}
              values={{ date: file.updatedAt }}
            />
          </p>
        </div>
      </div>

      <div className="file-card__footer">
        <div className="file-card__footer-left">
          <FileTypeBadge type={file.type} />
          <span className="file-card__size">{file.size}</span>
        </div>
        <div className="file-card__actions">
          {file.type !== 'pptx' && (
            <IconButton
              src={RiEyeLine}
              iconAs={Icon}
              alt={formatMessage(messages.previewFile, { name: file.name })}
              variant="ghost-secondary"
              size="inline"
              onClick={() => onPreview?.(file)}
            />
          )}
          <IconButton
            src={RiDownloadLine}
            iconAs={Icon}
            alt={formatMessage(messages.downloadFile, { name: file.name })}
            variant="ghost-secondary"
            size="inline"
            onClick={() => onDownload?.(file)}
          />
        </div>
      </div>
    </article>
  );
};

FileCard.propTypes = {
  file: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
  }).isRequired,
  onPreview: PropTypes.func,
  onDownload: PropTypes.func,
};

FileCard.defaultProps = {
  onPreview: undefined,
  onDownload: undefined,
};

export default FileCard;
